(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-live"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* per-instance init; kein globaler Lock */
  var components = document.querySelectorAll('[data-predictive-search]');
  if(!components.length) return;
  function debounce(fn, wait){var t;return function(){clearTimeout(t);var a=arguments;var c=this;t=setTimeout(function(){fn.apply(c,a)},wait)}}
  components.forEach(function(root){
    if(root.__psReady) return;
    root.__psReady = true;
    var form = root.querySelector('.search-live__form');
    var input = root.querySelector('.search-live__input');
    var results = root.querySelector('.search-live__results');
    var controller;
    function render(items){
      if(!items || !items.length){
        results.innerHTML = '<div class="search-live__empty">'+(input.value.trim() ? input.value.trim() : '')+'</div>';
        results.hidden = false;
        input.setAttribute('aria-expanded','false');
        return;
      }
      var html = '<ul class="search-live__results-list">'+items.map(function(p){
        var img = p.image ? '<img class="search-live__thumb" src="'+p.image+'" alt="'+p.title.replace(/"/g,'&quot;')+'" loading="lazy" width="40" height="40" />' : '<div class="search-live__thumb" aria-hidden="true"></div>';
        return '<li role="option"><a class="search-live__item" href="'+p.url+'">'+img+'<span class="search-live__title">'+p.title+'</span></a></li>';
      }).join('')+'</ul>';
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded','true');
    }
    function fetchResults(q){
      if(controller){controller.abort()}
      controller = new AbortController();
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var url = rootPath + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku';
      fetch(url,{signal:controller.signal,headers:{Accept:'application/json'}}).then(function(r){
        if(!r.ok) return {resources:{results:{products:[]}}};
        return r.json();
      }).then(function(data){
        var products = (((data||{}).resources||{}).results||{}).products || [];
        var items = products.map(function(p){
          var img = null;
          if (p.image) { img = typeof p.image === 'string' ? p.image : (p.image.url || null); }
          if (!img && p.featured_image) { img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.url || null); }
          if (!img && p.thumbnail) { img = p.thumbnail; }
          return {title:p.title,url:p.url,image:img};
        });
        render(items);
      }).catch(function(e){
        if(e.name==='AbortError') return;
        render([]);
      });
    }
    var onInput = debounce(function(e){
      var q = e.target.value.trim();
      if(!q){results.hidden=true;input.setAttribute('aria-expanded','false');results.innerHTML='';return}
      fetchResults(q);
    },160);
    input.addEventListener('input', onInput);
    input.addEventListener('focus', function(){
      var q = input.value.trim();
      if(q){fetchResults(q)}
    });
    document.addEventListener('click', function(e){
      if(!root.contains(e.target)){results.hidden=true;input.setAttribute('aria-expanded','false')}
    });
    form.addEventListener('submit', function(e){
      if(!input.value.trim()){e.preventDefault();input.focus()}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-slideshow"] && !Shopify.designMode) return;
  try {
    
function initSimpleSlideshow(root) {
  var track = root.querySelector('.simple-slideshow__track');
  if (!track) return;
  var slides = root.querySelectorAll('.simple-slideshow__slide');
  if (!slides || slides.length <= 1) return;
  var dots = root.querySelectorAll('.simple-slideshow__dot');
  var index = 0;
  var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
  var timer = null;

  function syncDots() {
    if (!dots || !dots.length) return;
    dots.forEach(function(btn, i) {
      if (i === index) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.removeAttribute('aria-current');
      }
    });
  }

  function goTo(i) {
    index = i;
    root.style.setProperty('--slide-index', index);
    syncDots();
  }

  function next() {
    var n = (index + 1) % slides.length;
    goTo(n);
  }

  function start() {
    stop();
    timer = setInterval(next, interval);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (dots && dots.length) {
    dots.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var i = parseInt(this.getAttribute('data-index') || '0', 10);
        stop();
        goTo(i);
        start();
      });
    });
  }

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  goTo(0);
  start();
}

document.querySelectorAll('.simple-slideshow').forEach(initSimpleSlideshow);

  } catch(e) { console.error(e); }
})();
})();
